import { csrfToken } from '../../../../../Greativ/global/csrf'
import axios from 'axios'

export const httpInstance = axios.create({
  baseURL: 'get/api/template/basket',
  headers: {
    'X-CSRF-TOKEN': csrfToken,
  },
})
